export var EAuthMode;
(function (EAuthMode) {
  EAuthMode["Default"] = "default";
  EAuthMode["OneTap"] = "onetap";
})(EAuthMode || (EAuthMode = {}));
export var EAuthStatus;
(function (EAuthStatus) {
  EAuthStatus["Connected"] = "connected";
  EAuthStatus["NotAuthorized"] = "not_authorized";
  EAuthStatus["Unknown"] = "unknown";
})(EAuthStatus || (EAuthStatus = {}));